<template>
  <cs-view single-view>
    <template v-slot:content>
      <v-expansion-panels accordion>
        <v-expansion-panel>
          <v-expansion-panel-header class="title-1">CSButton</v-expansion-panel-header>
          <v-expansion-panel-content>
            <buttons-test />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="title-1"
            >CSIllustrationSelector</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <cs-illustration-selector-test />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </cs-view>
</template>
<script>
import { mapMutations } from 'vuex';
import { CSBase } from '@complispace/cs-design-system';
import * as types from '../store/mutationTypes';
import ButtonsTest from '../components/ButtonsTest';
import CSIllustrationSelectorTest from '../components/CSIllustrationSelectorTest';

export default {
  name: 'FormControls',

  components: {
    'buttons-test': ButtonsTest,
    'cs-illustration-selector-test': CSIllustrationSelectorTest
  },

  extends: CSBase,

  data() {
    return {};
  },
  async mounted() {
    this.setPageViewType('form-controls');
  },
  computed: {},
  methods: {
    ...mapMutations({
      setPageViewType: types.VIEW_TYPE_SET_PAGE_VIEW_TYPE
    })
  }
};
</script>

<style scoped></style>
